import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import Logo from "../assets/img/logo/logo.svg";

import line3 from "../assets/img/animated-icon/line-3.png";
import about3 from "../assets/img/about/about-3.png";
import about31 from "../assets/img/about/about-3-1.png";
import about32 from "../assets/img/about/0815ce0b5e9963d05df57d7fe072b81c.jpg";
import down1 from "../assets/img/down-1.png";
import down2 from "../assets/img/down-2.png";
import ammarSign from "../assets/img/signature 1.png";
import ceoPic from "../images/ceoPic.jpg";
import heroVideo from "../HMA TECS video.mp4";

// Service preview imagery — one per service, mapped by index
import serviceImg1 from "../images/profile/a061816721aebd2be0fb2c3f2d3f3658.jpg";
import serviceImg2 from "../images/profile/facepay_kiosks.jpg";
import serviceImg3 from "../images/profile/smart_city_crowd.jpg";
import serviceImg4 from "../images/profile/metro_turnstile.jpg";
import serviceImg5 from "../images/profile/port_cranes.jpg";
import serviceImg6 from "../images/profile/geo_drone.jpg";
import serviceImg7 from "../images/profile/voice_analytics.jpg";
import serviceImg8 from "../images/profile/legal_courtroom.jpg";

// Project imagery — sourced from Company Profile 2026 brochure
import projRealEstate from "../images/profile/real_estate_skyline.jpg";
import projFacePay from "../images/profile/facepay_kiosks.jpg";
import projSmartCity from "../images/profile/smart_city_crowd.jpg";
import projMetro from "../images/profile/metro_turnstile.jpg";
import projPort from "../images/profile/port_cranes.jpg";
import projGeo from "../images/profile/geo_drone.jpg";
import projVoice from "../images/profile/voice_analytics.jpg";
import projLegal from "../images/profile/legal_courtroom.jpg";
import projFraud from "../images/profile/anti_fraud.jpg";
import projArch from "../images/profile/Capture d’écran 2026-05-09 162632.jpg";
import projSupply from "../images/profile/port_cranes.jpg";
import projRetail from "../images/profile/retail_aisle.jpg";
import projMessaging from "../images/profile/secure_messenger.jpg";
import projbigdata from "../images/profile/big_data_graph.png";
import voice_analytics from "../images/profile/voice_analytics.jpg";
import transport from "../images/profile/transport.jpg";

// Partner logos — Powered by Global Ecosystem
import partner01 from "../images/partners/partner_01.jpg";
import partner02 from "../images/partners/partner_02.jpg";
import partner03 from "../images/partners/partner_03.jpg";
import partner04 from "../images/partners/partner_04.jpg";
import partner05 from "../images/partners/partner_05.jpg";
import partner06 from "../images/partners/partner_06.jpg";
import partner07 from "../images/partners/partner_07.jpg";
import partner08 from "../images/partners/partner_08.jpg";
import partner09 from "../images/partners/partner_09.jpg";
import partner10 from "../images/partners/partner_10.jpg";
import partner11 from "../images/partners/partner_11.jpg";
import partner12 from "../images/partners/partner_12.jpg";
import partner13 from "../images/partners/partner_13.jpg";
import partner14 from "../images/partners/partner_14.jpg";
import evpCurtiss from "../images/events partners/curtiss.jpeg";
import evpS4ga from "../images/events partners/s4ga.jpeg";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { isEmpty } from "lodash";
import ReactSelect from "react-select";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";


import {
  Sparkles,
  Cpu,
  Globe2,
  Layers3,
  ShieldCheck,
  BrainCircuit,
  Orbit,
  Bot,
  Workflow,
  Radar,
  ArrowUpRight,
} from "lucide-react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import {
  Reveal,
  StaggerWords,
  MagneticCTA,
  AnimatedCounter,
  Parallax,
  OrnamentalDivider,
  GoldSeal,
  KineticMarquee,
} from "../motion";

const partnerLogos = [
  evpCurtiss, evpS4ga,
  partner01, partner02, partner03, partner04, partner05, partner06, partner07,
  partner08, partner09, partner10, partner11, partner12, partner13, partner14,
];
const partnerLogosRow1 = partnerLogos.slice(0, 7);
const partnerLogosRow2 = partnerLogos.slice(7);

const homeServicePreviewImages = [
  serviceImg1,
  serviceImg2,
  serviceImg3,
  serviceImg4,
  serviceImg5,
  serviceImg6,
  serviceImg7,
  serviceImg8,
];

const defaultServices = [
  {
    title: "Web Development",
    titleFR: "Développement Web",
    titleAR: "تطوير الويب",
    description:
      "Modern, responsive websites and progressive web apps built with React, Next.js and best-in-class performance and accessibility standards.",
    descriptionFR:
      "Sites Web modernes et réactifs et applications Web progressives développés avec React, Next.js et des normes de performance et d'accessibilité de premier ordre.",
    descriptionAR:
      "مواقع وتطبيقات ويب حديثة ومتجاوبة مبنية باستخدام React وNext.js مع أعلى معايير الأداء وسهولة الوصول.",
  },
  {
    title: "Mobile Applications",
    titleFR: "Applications mobiles",
    titleAR: "تطبيقات الجوال",
    description:
      "Native and cross-platform iOS and Android apps using React Native and Flutter, optimized for speed, reliability and seamless user experience.",
    descriptionFR:
      "Applications iOS et Android natives et multiplateformes utilisant React Native et Flutter, optimisées pour la rapidité, la fiabilité et une expérience utilisateur fluide.",
    descriptionAR:
      "تطبيقات iOS وAndroid أصلية ومتعددة المنصات باستخدام React Native وFlutter، محسّنة للسرعة والموثوقية وتجربة مستخدم سلسة.",
  },
  {
    title: "AI & Machine Learning",
    titleFR: "IA et apprentissage automatique",
    titleAR: "الذكاء الاصطناعي والتعلم الآلي",
    description:
      "Custom AI models, NLP pipelines, computer vision and predictive analytics to automate decisions and unlock new business value from your data.",
    descriptionFR:
      "Modèles IA personnalisés, pipelines NLP, vision par ordinateur et analyses prédictives pour automatiser les décisions et créer de la valeur à partir de vos données.",
    descriptionAR:
      "نماذج ذكاء اصطناعي مخصصة، وأنظمة معالجة لغة طبيعية، ورؤية حاسوبية، وتحليلات تنبؤية لأتمتة القرارات وتحقيق قيمة جديدة من بياناتك.",
  },
  {
    title: "IoT Solutions",
    titleFR: "Solutions IoT",
    titleAR: "حلول إنترنت الأشياء",
    description:
      "End-to-end IoT platforms with sensors, edge computing, secure connectivity and real-time dashboards for smart cities, industry and healthcare.",
    descriptionFR:
      "Plateformes IoT complètes avec capteurs, edge computing, connectivité sécurisée et tableaux de bord en temps réel pour villes intelligentes, industrie et santé.",
    descriptionAR:
      "منصات إنترنت الأشياء الشاملة مع أجهزة استشعار، وحوسبة طرفية، واتصال آمن، ولوحات معلومات فورية للمدن الذكية والصناعة والرعاية الصحية.",
  },
  {
    title: "Cloud & DevOps",
    titleFR: "Cloud et DevOps",
    titleAR: "السحابة و DevOps",
    description:
      "AWS, Azure and GCP architectures, CI/CD pipelines, Kubernetes orchestration and SRE practices that keep your systems scalable and resilient.",
    descriptionFR:
      "Architectures AWS, Azure et GCP, pipelines CI/CD, orchestration Kubernetes et pratiques SRE pour des systèmes évolutifs et résilients.",
    descriptionAR:
      "هياكل AWS وAzure وGCP، وخطوط CI/CD، وتنسيق Kubernetes، وممارسات SRE للحفاظ على أنظمتك قابلة للتوسع ومرنة.",
  },
  {
    title: "Cybersecurity",
    titleFR: "Cybersécurité",
    titleAR: "الأمن السيبراني",
    description:
      "Security audits, penetration testing, ISO 27001 readiness and 24/7 SOC monitoring to protect your data, customers and reputation.",
    descriptionFR:
      "Audits de sécurité, tests de pénétration, préparation ISO 27001 et surveillance SOC 24/7 pour protéger vos données, vos clients et votre réputation.",
    descriptionAR:
      "تدقيقات أمنية، واختبارات اختراق، وجاهزية ISO 27001، ومراقبة SOC على مدار الساعة لحماية بياناتك وعملائك وسمعتك.",
  },
  {
    title: "UI/UX Design",
    titleFR: "Conception UI/UX",
    titleAR: "تصميم واجهة وتجربة المستخدم",
    description:
      "User research, design systems, prototyping and accessibility-first interfaces crafted in Figma to delight your users on every screen.",
    descriptionFR:
      "Recherche utilisateur, design systems, prototypage et interfaces axées sur l'accessibilité conçues dans Figma pour ravir vos utilisateurs.",
    descriptionAR:
      "أبحاث المستخدم، وأنظمة التصميم، والنماذج الأولية، وواجهات تركز على سهولة الوصول، مصممة في Figma لإسعاد المستخدمين على كل شاشة.",
  },
  {
    title: "IT Consulting",
    titleFR: "Conseil informatique",
    titleAR: "الاستشارات التقنية",
    description:
      "Strategic technology advisory, digital transformation roadmaps and innovation management to align IT investments with business goals.",
    descriptionFR:
      "Conseil stratégique en technologie, feuilles de route de transformation numérique et gestion de l'innovation pour aligner l'IT sur vos objectifs.",
    descriptionAR:
      "استشارات تكنولوجية استراتيجية، وخرائط طريق للتحول الرقمي، وإدارة الابتكار لمواءمة استثمارات تقنية المعلومات مع أهداف الأعمال.",
  },
];

const defaultProjects = [
  {
    name: "Moscow Metro",
    nameFR: "Métro de Moscou",
    nameAR: "مترو موسكو",
    client: "Biometric Security System",
    clientFR: "Système biométrique de sécurité",
    clientAR: "نظام أمني بيومتري",
    description:
      "Moscow Metro employs facial and biometric recognition to streamline access and enhance security with instant identification systems.",
    descriptionFR:
      "Le métro de Moscou utilise la reconnaissance faciale et biométrique pour accélérer l’accès et renforcer la sécurité.",
    descriptionAR:
      "يستخدم مترو موسكو تقنيات التعرف على الوجه والبيومترية لتسريع الدخول وتعزيز الأمان.",
    images: [projMetro],
    link: "#",
  },

  {
    name: "Cross-Channel Fraud System",
    nameFR: "Système anti-fraude cross-canal",
    nameAR: "نظام مكافحة الاحتيال متعدد القنوات",
    client: "AI Fraud Detection",
    clientFR: "Détection de fraude IA",
    clientAR: "كشف الاحتيال بالذكاء الاصطناعي",
    description:
      "Real-time fraud detection using ML/LLM and multi-source data fusion.",
    descriptionFR:
      "Détection en temps réel de fraude via ML/LLM et fusion de données.",
    descriptionAR:
      "كشف الاحتيال في الوقت الحقيقي باستخدام الذكاء الاصطناعي.",
    images: [projFraud],
    link: "#",
  },

  {
    name: "FacePay Biometric Payments",
    nameFR: "Paiement biométrique FacePay",
    nameAR: "فيس باي للدفع البيومتري",
    client: "1.5M+ Terminals",
    clientFR: "1.5M+ terminaux",
    clientAR: "أكثر من 1.5 مليون جهاز",
    description:
      "Contactless biometric payments via facial recognition across nationwide terminals.",
    descriptionFR:
      "Paiement biométrique sans contact via reconnaissance faciale.",
    descriptionAR:
      "مدفوعات بدون لمس عبر التعرف على الوجه.",
    images: [projFacePay],
    link: "#",
  },
{
  name: "Voice Processing & Analytics",
  nameFR: "Traitement vocal et analytique",
  nameAR: "معالجة الصوت والتحليلات",
  client: "Voice AI & Deepfake Detection",
  clientFR: "IA vocale & détection Deepfake",
  clientAR: "الذكاء الصوتي واكتشاف التزييف",
  description:
    "High-level architecture diagram for voice processing and analytics, including audio data import, voiceprint creation, speech-to-text, language detection, speaker separation, spoofing and Deepfake detection, and communication analysis.",
  descriptionFR:
    "Schéma de l’architecture high-level pour le traitement de la voix, incluant l'importation de données audio, création de voiceprints, reconnaissance vocale, détection de langage, séparation de locuteurs, détection de spoofing et Deepfake, ainsi que l’analyse conversationnelle.",
  descriptionAR:
    "مخطط لبنية عالية المستوى لمعالجة الصوت والتحليلات، يتضمن استيراد البيانات الصوتية، إنشاء بصمات الصوت، التعرف على الكلام، اكتشاف اللغة، فصل المتحدثين، الكشف عن التزوير، وتحليل المحادثات.",
  images: [voice_analytics],
  link: "#",
},

  {
    name: "Smart & Safe City",
    nameFR: "Ville intelligente et sécurisée",
    nameAR: "مدينة ذكية وآمنة",
    client: "National AI Surveillance",
    clientFR: "Surveillance IA nationale",
    clientAR: "مراقبة ذكية وطنية",
    description:
      "Urban surveillance with facial recognition and behavior detection systems.",
    descriptionFR:
      "Surveillance urbaine avec reconnaissance faciale.",
    descriptionAR:
      "مراقبة حضرية باستخدام الذكاء الاصطناعي.",
    images: [projSmartCity],
    link: "#",
  },

  {
    name: "Big Data Security Analytics",
    nameFR: "Analyse Big Data pour la sécurité",
    nameAR: "تحليل البيانات الضخمة للأمن",
    client: "OSINT & Telecom Data",
    clientFR: "Télécom & OSINT",
    clientAR: "بيانات الاتصالات والمصادر المفتوحة",
    description:
      "Multi-source analytics for anomaly detection and geospatial monitoring.",
    descriptionFR:
      "Analyse multi-sources pour la sécurité.",
    descriptionAR:
      "تحليل البيانات للكشف عن الأنماط.",
    images: [projbigdata],
    link: "#",
  },

  {
    name: "National Real Estate Platform",
    nameFR: "Plateforme immobilière nationale",
    nameAR: "منصة العقارات الوطنية",
    client: "18M Users",
    clientFR: "18M utilisateurs",
    clientAR: "18 مليون مستخدم",
    description:
      "Unified real estate ecosystem connecting developers, banks and notaries.",
    descriptionFR:
      "Écosystème immobilier unifié.",
    descriptionAR:
      "منصة عقارية موحدة.",
    images: [projRealEstate],
    link: "#",
  },

  {
    name: "Secure Government Messaging",
    nameFR: "Messagerie gouvernementale sécurisée",
    nameAR: "مراسلة حكومية آمنة",
    client: "Matrix / Element",
    clientFR: "Matrix / Element",
    clientAR: "Matrix / Element",
    description:
      "End-to-end encrypted government communication platform.",
    descriptionFR:
      "Plateforme de communication sécurisée.",
    descriptionAR:
      "منصة مراسلة حكومية آمنة.",
    images: [projMessaging],
    link: "#",
  },

  {
    name: "Legal AI Transformation",
    nameFR: "Transformation juridique IA",
    nameAR: "التحول القانوني بالذكاء الاصطناعي",
    client: "Judicial Systems",
    clientFR: "Systèmes judiciaires",
    clientAR: "النظام القضائي",
    description:
      "AI transcription and case management for courts.",
    descriptionFR:
      "Système juridique intelligent.",
    descriptionAR:
      "نظام قانوني ذكي.",
    images: [projLegal],
    link: "#",
  },

  {
    name: "Retail AI Optimization",
    nameFR: "Optimisation retail IA",
    nameAR: "تحسين التجزئة بالذكاء الاصطناعي",
    client: "Retail Chains",
    clientFR: "Chaînes de magasins",
    clientAR: "سلاسل البيع",
    description:
      "AI-powered inventory and customer behavior analytics.",
    descriptionFR:
      "Optimisation des stocks via IA.",
    descriptionAR:
      "تحليل المخزون بالذكاء الاصطناعي.",
    images: [projRetail],
    link: "#",
  },

  {
    name: "Transport AI System",
    nameFR: "Système de transport intelligent",
    nameAR: "نظام النقل الذكي",
    client: "Metro & Airports",
    clientFR: "Métro & Aéroports",
    clientAR: "المترو والمطارات",
    description:
      "AI assistants and biometric payments for transport systems.",
    descriptionFR:
      "Système de transport intelligent.",
    descriptionAR:
      "نظام نقل ذكي.",
    images: [transport],
    link: "#",
  },

  {
    name: "Supply Chain AI",
    nameFR: "Chaîne logistique IA",
    nameAR: "سلسلة التوريد الذكية",
    client: "Ports & Logistics",
    clientFR: "Ports & logistique",
    clientAR: "الموانئ واللوجستيك",
    description:
      "RFID tracking and AI logistics optimization.",
    descriptionFR:
      "Optimisation logistique IA.",
    descriptionAR:
      "تحسين سلسلة التوريد.",
    images: [projSupply],
    link: "#",
  },

  {
    name: "Geo Analytics AI",
    nameFR: "Analyse géospatiale IA",
    nameAR: "تحليل جغرافي ذكي",
    client: "Satellite & Drone AI",
    clientFR: "IA satellites & drones",
    clientAR: "الأقمار الصناعية والطائرات",
    description:
      "AI-based satellite and drone image analysis.",
    descriptionFR:
      "Analyse satellite intelligente.",
    descriptionAR:
      "تحليل صور الأقمار الصناعية.",
    images: [projGeo],
    link: "#",
  },

  {
    name: "AI Platform Architecture",
    nameFR: "Architecture plateforme IA",
    nameAR: "بنية منصة الذكاء الاصطناعي",
    client: "Enterprise AI",
    clientFR: "IA entreprise",
    clientAR: "ذكاء اصطناعي مؤسسات",
    description:
      "High-level architecture integrating APIs, ML models and data pipelines.",
    descriptionFR:
      "Architecture IA globale.",
    descriptionAR:
      "بنية منصة الذكاء الاصطناعي.",
    images: [projArch],
    link: "#",
  },
];

const defaultConfigurations = {
  phone: "+97444303443",
  email: "sales@hmatechs.com",
  address: "QFC Tower, Doha, Qatar",
  addressFR: "Tour QFC, Doha, Qatar",
  addressAR: "برج QFC، الدوحة، قطر",
  openingDayStart: "Sunday",
  openingDayStartFR: "Dimanche",
  openingDayStartAR: "الأحد",
  openingDayEnd: "Thursday",
  openingDayEndFR: "Jeudi",
  openingDayEndAR: "الخميس",
  openingHourStart: "9:00 AM",
  openingHourStartFR: "9h00",
  openingHourStartAR: "9:00 صباحًا",
  openingHourEnd: "6:00 PM",
  openingHourEndFR: "18h00",
  openingHourEndAR: "6:00 مساءً",
};

const Home = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const [fullName, setfullName] = useState([]);
  const [skype, setskype] = useState([]);
  const [phone, setphone] = useState([]);
  const [email, setemail] = useState([]);
  const [message, setmessage] = useState([]);
  const [modalopen, setmodalopen] = useState(false);
  const [item, setitem] = useState({});

  const [hoverService, setHoverService] = useState(null);
  const [previewPos, setPreviewPos] = useState({ x: 0, y: 0 });
  const [lang, setlang] = useState({ value: "EN", label: "EN" });

  const [menu, setmenu] = useState(false);
  document.documentElement.dir = lang.value === "AR" && "rtl"; // for rtl

  useEffect(() => {
    const onScroll = () => {
      const h = document.querySelector("header.header");
      if (!h) return;
      h.classList.toggle("is-scrolled", window.scrollY > 24);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Lock body scroll + close on Escape when burger menu is open
  useEffect(() => {
    if (menu) {
      document.body.style.overflow = "hidden";
      const onKey = (e) => e.key === "Escape" && setmenu(false);
      window.addEventListener("keydown", onKey);
      return () => {
        document.body.style.overflow = "";
        window.removeEventListener("keydown", onKey);
      };
    }
  }, [menu]);

  const tr = (en, fr, ar) =>
    lang.value === "EN" ? en : lang.value === "FR" ? fr : ar;

  // Close menu + smooth-scroll to a hash target
  const navHash = (hash) => (e) => {
    e.preventDefault();
    setmenu(false);
    requestAnimationFrame(() => {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    });
  };

  // Close menu + navigate to a route (no reload)
  const navRoute = (path) => (e) => {
    e.preventDefault();
    setmenu(false);
    setTimeout(() => navigate(path), 80);
  };

  useEffect(() => {
    if (
      localStorage.getItem("lang") &&
      JSON.parse(localStorage.getItem("lang"))
    ) {
      setlang(JSON.parse(localStorage.getItem("lang")));
    }
    axios
      .get("https://hmatechs.com/api/statistic/AllData")
      .then((response) => {
        if (response?.data) {
          setData(response?.data);
        }
      })
      .catch(() => {
        setData({});
      });
  }, []);
const [selectedProject, setSelectedProject] = useState(null);
const [homeProjectCount, setHomeProjectCount] = useState(6);

  const closeModal = () => setSelectedProject(null);
  const services =
    Array.isArray(data?.Service) && data.Service.length > 0
      ? data.Service
      : defaultServices;
  const projects =
    Array.isArray(data?.Project) && data.Project.length > 0
      ? data.Project
      : defaultProjects;
  const partners = Array.isArray(data?.Parteners) ? data.Parteners : [];
  const config = isEmpty(data?.Configurations)
    ? defaultConfigurations
    : data.Configurations;

  const addContact = async () => {
    await axios
      .post("https://hmatechs.com/api/contact", {
        fullName,
        skype,
        phone,
        email,
        message,
      })
      .then((response) => {})
      .catch(function (err) {});
  };

  const handelOpenModal = (e) => {
    setmodalopen(true);
    setitem(e);
  };

  return (
    <>
      <header className="header">
        <div className="container">
          <nav>
            <a href="#homeid" onClick={navHash("homeid")}>
              <div className="logo">
                <img src={Logo} alt="HMA Techs" />
              </div>
            </a>

            <input
              type="checkbox"
              id="checkbox"
              checked={menu}
              onChange={(e) => setmenu(e.target.checked)}
            />
            <label htmlFor="checkbox" id="icon" aria-label="Toggle menu">
              <svg
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={
                    menu
                      ? "M6 6L18 18M6 18L18 6"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                ></path>
              </svg>
            </label>
            <ul onClick={(e) => e.target === e.currentTarget && setmenu(false)}>
              <li>
                <a href="#homeid" onClick={navHash("homeid")}>
                  {lang.value === "EN"
                    ? `Home`
                    : lang.value === "FR"
                      ? `Accueil`
                      : `الصفحة الرئيسية`}
                </a>
              </li>
              <li>
                <a href="#aboutid" onClick={navHash("aboutid")}>
                  {lang.value === "EN"
                    ? `About`
                    : lang.value === "FR"
                      ? `À propos de nous`
                      : `معلومات عنا`}
                </a>
              </li>
              <li>
                <a href="#projectsid" onClick={navHash("projectsid")}>
                  {lang.value === "EN"
                    ? `Portfolio`
                    : lang.value === "FR"
                      ? `Portefeuille`
                      : `المشاريع`}
                </a>
              </li>
              <li>
                <a href="#Servicesid" onClick={navHash("Servicesid")}>
                  {lang.value === "EN"
                    ? `Services`
                    : lang.value === "FR"
                      ? `Services`
                      : `خدمات`}
                </a>
              </li>
              <li>
                <a href="#contactid" onClick={navHash("contactid")}>
                  {lang.value === "EN"
                    ? `Contact`
                    : lang.value === "FR"
                      ? `Contact`
                      : `اتصال`}
                </a>
              </li>

               <li>
                 <a href="/events" onClick={navRoute("/events")}>
                   {lang.value === "EN"
                     ? `HMA Events`
                     : lang.value === "FR"
                       ? `Événements HMA`
                       : `فعاليات HMA`}
                 </a>
               </li>
               <li>
                 <a href="/clients" onClick={navRoute("/clients")}>
                   {lang.value === "EN"
                     ? `Clients`
                     : lang.value === "FR"
                       ? `Clients`
                       : `العملاء`}
                 </a>
               </li>
             </ul>
            <ReactSelect
              className="selectLang"
              isSearchable={false}
              value={lang}
              onChange={(val) => {
                setlang(val);
                localStorage.setItem("lang", JSON.stringify(val));
              }}
              theme={(theme) => ({
                ...theme,
                //borderRadius: 0,
                borderStyle: "none",
                boxShadow: "none",
                colors: {
                  ...theme.colors,
                  /*
                   * control/backgroundColor
                   * menu/backgroundColor
                   * option/color(selected)
                   */
                  neutral0: "#0d0c1c",
                  neutral30: "#0d0c1c", //control/borderColor(focused)
                  neutral10: "#fff",
                  neutral50: "#000", // pacleholder color
                  neutral80: "#fff", //input color
                  primary25: "#c1c1c1", //option bg color focued
                  primary: "#238aec", //option bg color selected
                  primary50: "#238aec", // option bg color active(enavled or available)
                },
              })}
              styles={{
                control: (base) => ({
                  ...base,
                  border: 0,
                  // This line disable the blue border
                  boxShadow: "none",
                }),

                option: (base) => ({
                  ...base,
                  color: "#fff",
                }),
              }}
              options={[
                { value: "EN", label: "EN" },
                { value: "FR", label: "FR" },
                { value: "AR", label: "AR" },
              ]}
            />
          </nav>
        </div>
      </header>

      {/* Mobile menu — portal'd to body to escape any containing block */}
      {createPortal(
        <AnimatePresence>
          {menu && (
            <motion.div
              key="mobile-menu"
              className="hma-mobile-menu"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.target === e.currentTarget && setmenu(false)}
            >
              <button
                type="button"
                className="hma-mobile-menu__close"
                onClick={() => setmenu(false)}
                aria-label="Close menu"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                  <path d="M6 6L18 18M6 18L18 6" strokeLinecap="round" />
                </svg>
              </button>

              <span className="hma-mobile-menu__eyebrow">
                {lang.value === "EN"
                  ? "Menu"
                  : lang.value === "FR"
                    ? "Menu"
                    : "القائمة"}
              </span>

              <ul className="hma-mobile-menu__list">
                {[
                  { hash: "homeid", labels: ["Home", "Accueil", "الصفحة الرئيسية"] },
                  { hash: "aboutid", labels: ["About", "À propos", "معلومات عنا"] },
                  { hash: "projectsid", labels: ["Portfolio", "Portefeuille", "المشاريع"] },
                  { hash: "Servicesid", labels: ["Services", "Services", "خدمات"] },
                  { hash: "contactid", labels: ["Contact", "Contact", "اتصال"] },
                ].map((item, i) => (
                  <motion.li
                    key={item.hash}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.1 + i * 0.06, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                  >
                    <a href={`#${item.hash}`} onClick={navHash(item.hash)}>
                      <span className="hma-mobile-menu__num">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="hma-mobile-menu__label">
                        {lang.value === "EN"
                          ? item.labels[0]
                          : lang.value === "FR"
                            ? item.labels[1]
                            : item.labels[2]}
                      </span>
                    </a>
                  </motion.li>
                ))}
              </ul>

                <motion.a
                 href="/events"
                 onClick={navRoute("/events")}
                 className="hma-mobile-menu__cta"
                 initial={{ opacity: 0, y: 16 }}
                 animate={{ opacity: 1, y: 0 }}
                 transition={{ delay: 0.5, duration: 0.5 }}
               >
                 {lang.value === "EN"
                   ? "HMA Events →"
                   : lang.value === "FR"
                     ? "Événements HMA →"
                     : "فعاليات HMA →"}
               </motion.a>

               <motion.a
                 href="/clients"
                 onClick={navRoute("/clients")}
                 className="hma-mobile-menu__cta"
                 style={{ marginTop: 8 }}
                 initial={{ opacity: 0, y: 16 }}
                 animate={{ opacity: 1, y: 0 }}
                 transition={{ delay: 0.55, duration: 0.5 }}
               >
                 {lang.value === "EN"
                   ? "Clients →"
                   : lang.value === "FR"
                     ? "Clients →"
                     : "العملاء →"}
               </motion.a>

               <motion.div
                className="hma-mobile-menu__lang"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.4 }}
              >
                <span className="hma-mobile-menu__lang-label">
                  {lang.value === "EN"
                    ? "Language"
                    : lang.value === "FR"
                      ? "Langue"
                      : "اللغة"}
                </span>
                <div className="hma-mobile-menu__lang-group" role="group">
                  {[
                    { value: "EN", label: "EN" },
                    { value: "FR", label: "FR" },
                    { value: "AR", label: "AR" },
                  ].map((opt) => (
                    <button
                      key={opt.value}
                      type="button"
                      className={`hma-mobile-menu__lang-btn ${
                        lang.value === opt.value ? "is-active" : ""
                      }`}
                      onClick={() => {
                        setlang(opt);
                        localStorage.setItem("lang", JSON.stringify(opt));
                      }}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              </motion.div>

              <span className="hma-mobile-menu__footer">
                CREATIVITY · INNOVATION · FUTURE
              </span>
            </motion.div>
          )}
        </AnimatePresence>,
        document.body
      )}
      {/* header menu end */}
      {/* hero area */}
      <div className="hero pt-100 pb-100 hero-walpaper" id="homeid">
        <video
          className="hero-bg-video"
          src={heroVideo}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        />
        <div className="hero-bg-overlay" />

        {/* Editorial wordmark watermark */}
        <motion.div
          className="home-hero-watermark"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.6, delay: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          HMA<span>.</span>
        </motion.div>

        {/* Floating gold seal */}
        <motion.div
          className="home-hero-seal"
          initial={{ opacity: 0, scale: 0.6, rotate: -20 }}
          animate={{ opacity: 1, scale: 1, rotate: 0 }}
          transition={{ duration: 1.2, delay: 1.2, ease: [0.22, 1, 0.36, 1] }}
        >
          <GoldSeal
            topText="HMA · TECHS · DOHA"
            bottomText="INNOVATION · SINCE · 2009"
            // centerLabel="✺"
            size={130}
          />
        </motion.div>

        {/* Scroll indicator */}
        <motion.div
          className="home-hero-scroll"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.8, duration: 0.8 }}
        >
          <span>SCROLL</span>
          <motion.div
            className="line"
            animate={{ scaleY: [0, 1, 0], y: [0, 0, 60] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          />
        </motion.div>
      </div>
      {/* hero area end */}

      {/* trusted partners — moved under hero */}
<section
  id="partnersid"
  style={{
    background:
      "radial-gradient(circle at top right, rgba(201,161,74,0.05), transparent 40%), radial-gradient(circle at bottom left, rgba(236,200,121,0.03), transparent 40%), #ffffff",
    position: "relative",
    overflow: "hidden",
    padding: window.innerWidth < 768 ? "80px 0" : "120px 0",
  }}
>
  {/* GLOW */}
  <div
    style={{
      position: "absolute",
      width: "600px",
      height: "600px",
      borderRadius: "50%",
      background: "rgba(201,161,74,0.12)",
      filter: "blur(120px)",
      top: "-200px",
      right: "-150px",
      zIndex: 0,
    }}
  />

  <div style={{ position: "relative", zIndex: 2 }}>
    {/* TITLE */}
    <div style={{ textAlign: "center", marginBottom: 60 }}>
      <span
        style={{
          padding: "10px 22px",
          borderRadius: "999px",
          border: "1px solid rgba(201,161,74,0.3)",
          background: "rgba(201,161,74,0.08)",
          color: "#b8942e",
          fontSize: "13px",
          fontWeight: "700",
          letterSpacing: "2px",
          textTransform: "uppercase",
          display: "inline-flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <span
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            background: "#b8942e",
            boxShadow: "0 0 15px rgba(184,148,46,0.3)",
          }}
        />
        {lang.value === "EN"
          ? "Trusted Partners"
          : lang.value === "FR"
          ? "Partenaires de confiance"
          : "الشركاء"}
      </span>

      <h2
        style={{
          fontSize: window.innerWidth < 768 ? "32px" : "52px",
          color: "#1a1a1a",
          fontWeight: "900",
          marginTop: 25,
        }}
      >
        {lang.value === "EN"
          ? "Powered by Global Ecosystem"
          : lang.value === "FR"
          ? "Propulsé par un écosystème mondial"
          : "مدعوم بمنظومة عالمية"}
      </h2>

      <a
        href="/clients"
        onClick={navRoute("/clients")}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          marginTop: 20,
          padding: "12px 32px",
          borderRadius: 999,
          border: "1px solid rgba(220,38,38,0.3)",
          background: "transparent",
          color: "#dc2626",
          fontSize: 14,
          fontWeight: 700,
          letterSpacing: "1px",
          textTransform: "uppercase",
          textDecoration: "none",
          cursor: "pointer",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "rgba(220,38,38,0.08)";
          e.currentTarget.style.borderColor = "#dc2626";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.borderColor = "rgba(220,38,38,0.3)";
        }}
      >
        {lang.value === "EN"
          ? "See All Partners →"
          : lang.value === "FR"
          ? "Voir tous les partenaires →"
          : "عرض جميع الشركاء ←"}
      </a>
    </div>

    {/* MARQUEE ROW 1 */}
    <motion.div
      animate={{ x: ["0%", "-50%"] }}
      transition={{
        duration: 38,
        repeat: Infinity,
        ease: "linear",
      }}
      style={{
        display: "flex",
        gap: "28px",
        width: "max-content",
        marginBottom: "28px",
        willChange: "transform",
      }}
    >
      {[...partnerLogosRow1, ...partnerLogosRow1, ...partnerLogosRow1].map((src, i) => (
        <motion.div
          key={i}
          whileHover={{ scale: 1.08 }}
          style={{
            width: "240px",
            height: "160px",
            borderRadius: "28px",
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.98), rgba(248,247,244,0.95))",
            border: "1px solid rgba(0,0,0,0.06)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            overflow: "hidden",
            flexShrink: 0,
          }}
        >

          {/* LOGO */}
          <motion.img
            src={src}
            alt="partner"
            whileHover={{ scale: 1.15 }}
            style={{
              maxWidth: "82%",
              maxHeight: "82%",
              objectFit: "contain",
              zIndex: 2,
            }}
          />
        </motion.div>
      ))}
    </motion.div>

    {/* MARQUEE ROW 2 */}
    <motion.div
      animate={{ x: ["-50%", "0%"] }}
      transition={{
        duration: 44,
        repeat: Infinity,
        ease: "linear",
      }}
      style={{
        display: "flex",
        gap: "28px",
        width: "max-content",
        willChange: "transform",
      }}
    >
      {[...partnerLogosRow2, ...partnerLogosRow2, ...partnerLogosRow2].map((src, i) => (
        <motion.div
          key={i}
          whileHover={{ scale: 1.08 }}
          style={{
            width: "240px",
            height: "160px",
            borderRadius: "28px",
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.98), rgba(248,247,244,0.95))",
            border: "1px solid rgba(0,0,0,0.06)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            overflow: "hidden",
            flexShrink: 0,
          }}
        >

          <motion.img
            src={src}
            alt="partner"
            whileHover={{ scale: 1.15 }}
            style={{
              maxWidth: "82%",
              maxHeight: "82%",
              objectFit: "contain",
              zIndex: 2,
            }}
          />
        </motion.div>
      ))}
    </motion.div>
  </div>
</section>

      {/* kinetic marquee */}
      <KineticMarquee
        speed={50}
        items={[
          lang.value === "EN" ? "Innovation" : lang.value === "FR" ? "Innovation" : "ابتكار",
          lang.value === "EN" ? "Web Development" : lang.value === "FR" ? "Développement Web" : "تطوير الويب",
          lang.value === "EN" ? "Artificial Intelligence" : lang.value === "FR" ? "Intelligence Artificielle" : "الذكاء الاصطناعي",
          lang.value === "EN" ? "Mobile Apps" : lang.value === "FR" ? "Applications Mobiles" : "تطبيقات الجوال",
          lang.value === "EN" ? "Cloud Solutions" : lang.value === "FR" ? "Solutions Cloud" : "حلول سحابية",
          lang.value === "EN" ? "Digital Transformation" : lang.value === "FR" ? "Transformation Numérique" : "التحول الرقمي",
          lang.value === "EN" ? "IoT Systems" : lang.value === "FR" ? "Systèmes IoT" : "إنترنت الأشياء",
        ]}
      />

      {/* about — editorial spread */}
<section className="about-editorial refined-about" id="aboutid">
  <div className="about-editorial__watermark">About.</div>

  <div className="container">
    {/* HEADER */}
    <Reveal as="div" className="refined-about__head">
      <div className="refined-about__intro">
        <Reveal
          className="section__sub"
          y={20}
          duration={0.6}
          style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}
        >
          <span>
            {tr("Studio · Established", "Studio · Établi en", "ستوديو · تأسس")}
          </span>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 2,
              background: "linear-gradient(135deg, #c9a14a, #b8942e)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              fontWeight: 900,
            }}
          >
            <AnimatedCounter value={2009} />
          </span>
        </Reveal>

        <h2 className="refined-about__title">
          <StaggerWords
            key={lang.value} // IMPORTANT FIX
            text={tr(
              "Engineering trust at the speed of intelligence.",
              "Bâtir la confiance à la vitesse de l'intelligence.",
              "نهندس الثقة بسرعة الذكاء."
            )}
            highlightWords={[
              "intelligence.",
              "intelligence.",
              "الذكاء.",
            ]}
          />
        </h2>

        <p className="refined-about__text">
          {tr(
            "HMATech is a Doha-anchored studio building AI ecosystems, cloud platforms and digital experiences for the public sector and ambitious enterprises across MENA — backed by 17 years of practice and 5,000+ delivered projects.",
            "HMATech est un studio basé à Doha, qui conçoit des écosystèmes d'IA, des plateformes cloud et des expériences numériques pour le secteur public et les entreprises ambitieuses de la région MENA — fort de 17 ans de pratique et de plus de 5 000 projets livrés.",
            "ستوديو مقرّه الدوحة يبني منظومات الذكاء الاصطناعي ومنصّات سحابية وتجارب رقمية للقطاع العام والمؤسسات الطموحة في منطقة الشرق الأوسط وشمال إفريقيا — بخبرة 17 عامًا وأكثر من 5000 مشروع منفّذ."
          )}
        </p>
      </div>

      {/* RIGHT SIDE */}
      <div className="refined-about__side">
        {/* IMAGE */}
        <Reveal y={40} duration={1}>
          <div className="refined-about__image">
            <img src={about32} alt="HMATech studio" />

            {/* <div className="refined-about__image-badge">
              <span>01 / 01</span>

              <span>
                {tr("Doha ", "Doha ", "الدوحة ")}
              </span>
            </div> */}
          </div>
        </Reveal>

        {/* STATS */}
        <Reveal as="div" className="refined-about__stats" delay={0.15}>
          {[
            {
              num: <AnimatedCounter value={17} />,
              suffix: "+",
              label: tr(
                "Years of practice",
                "Années d'expérience",
                "سنة من الممارسة"
              ),
            },
            {
              num: <AnimatedCounter value={5000} />,
              suffix: "+",
              label: tr(
                "Projects delivered",
                "Projets livrés",
                "مشروع منفّذ"
              ),
            },
            {
              num: <AnimatedCounter value={40} />,
              suffix: "+",
              label: tr(
                "Government clients",
                "Clients gouvernementaux",
                "جهة حكومية"
              ),
            },
          ].map((s, i) => (
            <div className="refined-stat-card" key={i}>
              <span className="num">
                {s.num}
                <em>{s.suffix}</em>
              </span>

              <span className="label">{s.label}</span>
            </div>
          ))}
        </Reveal>
      </div>
    </Reveal>

    {/* STORY + APPROACH */}
    <div className="refined-about__body">
      <Reveal as="div" className="refined-about__chapter">
        <span className="chapter-tag">— Chapter 01</span>

        <h3>{tr("Our story", "Notre histoire", "قصّتنا")}</h3>

        <p>
          {tr(
            "Founded in Jordan and Tunisia in 2009, expanded into the GCC in 2015 and headquartered in Qatar since 2021. From day one we partnered with global tech leaders to bring niche ICT solutions, advisory and software to the region's most demanding institutions.",
            "Fondée en Jordanie et en Tunisie en 2009, étendue au Golfe en 2015 et installée au Qatar depuis 2021. Dès le premier jour, nous nous sommes associés aux leaders technologiques mondiaux pour apporter des solutions ICT, conseil et logiciels aux institutions les plus exigeantes de la région.",
            "تأسست في الأردن وتونس عام 2009، وتوسّعت في الخليج عام 2015، ومقرّها الرئيسي في قطر منذ 2021. منذ اليوم الأول، شراكاتنا مع كبار قادة التكنولوجيا في العالم لتقديم حلول ICT متخصّصة واستشارات وبرمجيات لأكثر مؤسسات المنطقة طموحًا."
          )}
        </p>
      </Reveal>

      <Reveal as="div" className="refined-about__chapter" delay={0.1}>
        <span className="chapter-tag">— Chapter 02</span>

        <h3>{tr("Our approach", "Notre approche", "أسلوبنا")}</h3>

        <p>
          {tr(
            "We combine artificial intelligence, cloud, automation, cybersecurity and immersive UX into one disciplined craft. Every brief is engineered with the same rigor — from discovery and architecture to deployment, training and long-term partnership.",
            "Nous combinons intelligence artificielle, cloud, automatisation, cybersécurité et UX immersive en un seul savoir-faire rigoureux. Chaque mission est conçue avec la même exigence — de la découverte et l'architecture au déploiement, à la formation et au partenariat durable.",
            "نجمع بين الذكاء الاصطناعي والحوسبة السحابية والأتمتة والأمن السيبراني وتجارب المستخدم الغامرة في حِرفة واحدة منضبطة. كل مهمة تُهندَس بالحرفية نفسها — من الاستكشاف والبنية إلى التنفيذ والتدريب والشراكة طويلة الأمد."
          )}
        </p>
      </Reveal>
    </div>
  </div>

  {/* STYLE */}
  <style jsx>{`
    .refined-about {
      position: relative;
      overflow: hidden;
    }

    .refined-about__head {
      display: grid;
      grid-template-columns: 1.15fr 0.85fr;
      gap: 50px;
      align-items: start;
      margin-bottom: 80px;
    }

    .refined-about__intro {
      padding-right: 10px;
    }

    .refined-about__title {
      font-size: clamp(52px, 5vw, 90px);
      line-height: 1.02;
      margin: 24px 0 28px;
      max-width: 820px;
    }

    /* FIX HIGHLIGHT COLOR */
    .refined-about__title .highlight,
    .refined-about__title strong,
    .refined-about__title em {
      color: #d4af37 !important;
    }

    .refined-about__text {
      max-width: 760px;
      font-size: 18px;
      line-height: 2;
      opacity: 0.78;
    }

    .refined-about__side {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    .refined-about__image {
      position: relative;
      overflow: hidden;
      border-radius: 34px;
      height: 430px;
      border: 1px solid rgba(212, 175, 55, 0.14);
    }

    .refined-about__image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .refined-about__image-badge {
      position: absolute;
      left: 22px;
      right: 22px;
      bottom: 22px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 18px;
      border-radius: 18px;
      background: rgba(0, 0, 0, 0.5);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(212, 175, 55, 0.16);
      color: #fff;
      font-size: 14px;
    }

    .refined-about__stats {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 18px;
    }

    .refined-stat-card {
      padding: 24px;
      border-radius: 24px;
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(212, 175, 55, 0.12);
      text-align: center;
    }

    .refined-stat-card .num {
      display: block;
      color: #fff;
      font-size: 34px;
      line-height: 1;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .refined-stat-card .num em {
      color: #d4af37;
      font-style: normal;
    }

    .refined-stat-card .label {
      color: rgba(255, 255, 255, 0.72);
      font-size: 13px;
      line-height: 1.6;
    }

    .refined-about__body {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }

    .refined-about__chapter {
      padding: 38px;
      border-radius: 30px;
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(212, 175, 55, 0.1);
    }

    .chapter-tag {
      display: inline-block;
      margin-bottom: 18px;
      color: #d4af37;
      font-weight: 600;
      letter-spacing: 0.5px;
    }

    .refined-about__chapter h3 {
      color: #fff;
      font-size: 34px;
      margin-bottom: 18px;
    }

    .refined-about__chapter p {
      margin: 0;
      line-height: 1.95;
      opacity: 0.78;
    }

    @media (max-width: 991px) {
      .refined-about__head,
      .refined-about__body {
        grid-template-columns: 1fr;
      }

      .refined-about__title {
        font-size: 54px;
      }

      .refined-about__image {
        height: 380px;
      }
    }

    @media (max-width: 767px) {
      .refined-about__title {
        font-size: 42px;
      }

      .refined-about__chapter {
        padding: 26px;
      }

      .refined-about__stats {
        grid-template-columns: 1fr;
      }

      .refined-about__image {
        height: 300px;
      }
    }
  `}</style>
</section>
      {/* about us end */}

      {/* service */}
<section className="service-editorial" id="Servicesid">
  <div className="service-editorial__watermark">Capabilities.</div>

  <div className="container">
    <Reveal as="div" className="service-editorial__head">
      <div>
        <h6 className="section__sub">
          {lang.value === "EN"
            ? "What We Do"
            : lang.value === "FR"
            ? "Notre métier"
            : "ما نُقدمه"}
        </h6>

        {/* FIXED TITLE */}
        <h3 className="section__title service-editorial__title">
          <StaggerWords
            key={lang.value}
            text={
              lang.value === "EN"
                ? "Engineering excellence"
                : lang.value === "FR"
                ? "Excellence en ingénierie"
                : "التميز الهندسي"
            }
            highlightWords={[
              "engineering",
              "ingénierie",
              "هندسي",
            ]}
          />
        </h3>
      </div>

      <div className="service-editorial__intro">
        <p>
          {lang.value === "EN"
            ? "From discovery to deployment — every brief is engineered with the same disciplined craft. Hover a capability to preview the work behind it."
            : lang.value === "FR"
            ? "De la découverte au déploiement — chaque mission est conçue avec la même rigueur. Survolez une capacité pour découvrir le travail."
            : "من الاستكشاف إلى الإطلاق — كل مهمة تُهندس بالحرفية نفسها. مرّر فوق أي قدرة لرؤية أعمالها."}
        </p>

        <span className="service-editorial__count">
          <span>01</span>
          <em>—</em>
          <span>{String(services.length).padStart(2, "0")}</span>
        </span>
      </div>
    </Reveal>

    <ul
      className="service-list"
      onMouseLeave={() => setHoverService(null)}
      onMouseMove={(ev) => {
        const r = ev.currentTarget.getBoundingClientRect();

        setPreviewPos({
          x: ev.clientX - r.left,
          y: ev.clientY - r.top,
        });
      }}
    >
      {services.map((e, i) => {
        const num = String(i + 1).padStart(2, "0");

        const tags =
          lang.value === "EN"
            ? [
                "Build",
                "Mobile",
                "Intelligence",
                "Connect",
                "Scale",
                "Defend",
                "Design",
                "Advise",
              ]
            : lang.value === "FR"
            ? [
                "Construire",
                "Mobile",
                "Intelligence",
                "Connecter",
                "Échelle",
                "Défendre",
                "Design",
                "Conseiller",
              ]
            : [
                "بناء",
                "جوال",
                "ذكاء",
                "اتصال",
                "توسع",
                "حماية",
                "تصميم",
                "استشارة",
              ];

        return (
          <motion.li
            key={i}
            className={`service-list__row ${
              hoverService === i ? "is-active" : ""
            } ${
              hoverService !== null && hoverService !== i
                ? "is-dimmed"
                : ""
            }`}
            onMouseEnter={() => setHoverService(i)}
            onClick={() => handelOpenModal(e)}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{
              duration: 0.7,
              delay: i * 0.05,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            <span className="service-list__num">— {num}</span>

            <h4 className="service-list__title">
              <span className="service-list__title-text">
                {lang.value === "EN"
                  ? e?.title
                  : lang.value === "FR"
                  ? e?.titleFR
                  : e?.titleAR}
              </span>
            </h4>

            <p className="service-list__desc">
              {lang.value === "EN"
                ? e?.description?.slice(0, 92) + "…"
                : lang.value === "FR"
                ? e?.descriptionFR?.slice(0, 92) + "…"
                : e?.descriptionAR?.slice(0, 92) + "…"}
            </p>

            <span className="service-list__tag">
              {tags[i % tags.length]}
            </span>

            <img src={homeServicePreviewImages[i]} alt="" className="service-list__thumb" />

            <span className="service-list__arrow" aria-hidden>
              <svg
                width="22"
                height="14"
                viewBox="0 0 22 14"
                fill="none"
              >
                <path
                  d="M1 7H20M20 7L14 1M20 7L14 13"
                  stroke="currentColor"
                  strokeWidth="1.4"
                  strokeLinecap="square"
                />
              </svg>
            </span>
          </motion.li>
        );
      })}

      {/* FLOATING PREVIEW */}
      <motion.div
        className="service-list__preview"
        animate={{
          x: previewPos.x,
          y: previewPos.y,
          opacity: hoverService !== null ? 1 : 0,
          scale: hoverService !== null ? 1 : 0.85,
        }}
        transition={{
          x: {
            type: "spring",
            stiffness: 220,
            damping: 24,
            mass: 0.4,
          },
          y: {
            type: "spring",
            stiffness: 220,
            damping: 24,
            mass: 0.4,
          },
          opacity: { duration: 0.25 },
          scale: {
            duration: 0.35,
            ease: [0.22, 1, 0.36, 1],
          },
        }}
      >
        {homeServicePreviewImages.map((src, i) => (
          <motion.img
            key={i}
            src={src}
            alt=""
            animate={{
              opacity: hoverService === i ? 1 : 0,
              scale: hoverService === i ? 1 : 1.06,
            }}
            transition={{
              duration: 0.5,
              ease: [0.22, 1, 0.36, 1],
            }}
          />
        ))}
      </motion.div>
    </ul>
  </div>

  {/* TITLE FIX */}
  <style>{`
    body.hma-dark .service-list__thumb {
      display: none;
    }
    .service-editorial__title {
      width: 100%;
      max-width: 860px;
      display: block !important;
      white-space: normal !important;
      line-height: 1.06 !important;
      word-break: normal;
    }

    .service-editorial__title span,
    .service-editorial__title div {
      white-space: normal !important;
    }

    .service-editorial__title .highlight,
    .service-editorial__title strong,
    .service-editorial__title em {
      color: #d4af37 !important;
    }

    @media (max-width: 991px) {
      .service-editorial__title {
        max-width: 100%;
        font-size: clamp(40px, 6vw, 60px);
        line-height: 1.1 !important;
      }
      body.hma-dark .service-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: 30px;
      }
      body.hma-dark .service-list__row {
        display: flex;
        align-items: center;
        gap: 0;
        padding: 0;
        background: var(--hma-surface, #fff);
        border: 1px solid rgba(201,161,74,0.1);
        border-radius: 16px;
        cursor: pointer;
        transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
        margin-bottom: 0;
        overflow: hidden;
        box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(201,161,74,0.04);
      }
      body.hma-dark .service-list__row:active {
        border-color: rgba(201,161,74,0.25);
        box-shadow: 0 4px 16px -8px rgba(201,161,74,0.15);
        transform: scale(0.985);
      }
      body.hma-dark .service-list__row:hover {
        border-color: rgba(201,161,74,0.18);
        box-shadow: 0 2px 8px rgba(0,0,0,0.05), 0 6px 20px -8px rgba(201,161,74,0.08);
      }
      body.hma-dark .service-list__num,
      body.hma-dark .service-list__desc,
      body.hma-dark .service-list__tag {
        display: none !important;
      }
      body.hma-dark .service-list__title {
        flex: 1;
        margin: 0;
        padding: 0 10px 0 8px;
        font-size: 1.05rem;
        font-weight: 600;
        font-family: var(--serif-display);
        letter-spacing: -0.01em;
        color: var(--hma-fg, #1a1a1a);
        white-space: normal;
        word-break: break-word;
        line-height: 1.3;
      }
      body.hma-dark .service-list__thumb {
        display: block !important;
        width: 100px;
        height: 84px;
        object-fit: cover;
        flex-shrink: 0;
        order: -1;
        border-radius: 14px;
        margin: 6px 0 6px 6px;
      }
      body.hma-dark .service-list__arrow {
        display: flex !important;
        width: 34px;
        height: 34px;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        margin-right: 14px;
        border-radius: 50%;
        background: rgba(201,161,74,0.07);
        color: var(--hma-gold, #c9a14a);
        font-size: 16px;
        transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
      }
      body.hma-dark .service-list__row:active .service-list__arrow {
        background: var(--hma-gold, #c9a14a);
        color: #fff;
        transform: translateX(3px) scale(0.92);
      }
      body.hma-dark .service-list__row:hover .service-list__arrow {
        background: rgba(201,161,74,0.12);
      }
      body.hma-dark .service-list__arrow svg {
        display: none;
      }
      body.hma-dark .service-list__arrow::after {
        content: "→";
        font-weight: 500;
      }
    }
    @media (max-width: 767px) {
      .service-editorial__title {
        font-size: 34px !important;
        line-height: 1.15 !important;
      }
    }
  `}</style>
</section>
      {/* service end */}

      {/* second kinetic marquee — between services and projects */}
      <div style={{ marginTop: 20, marginBottom: 10 }}>
        <KineticMarquee
          speed={42}
          italic={false}
          items={[
            "★",
            lang.value === "EN" ? "Strategy" : lang.value === "FR" ? "Stratégie" : "استراتيجية",
            "✺",
            lang.value === "EN" ? "Design" : lang.value === "FR" ? "Design" : "تصميم",
            "★",
            lang.value === "EN" ? "Engineering" : lang.value === "FR" ? "Ingénierie" : "هندسة",
            "✺",
            lang.value === "EN" ? "Launch" : lang.value === "FR" ? "Lancement" : "إطلاق",
          ]}
        />
      </div>
      {/* our project */}
<section className="project pt-100 pb-100" id="projectsid">
  <div className="container">
    {/* HEADER */}
    <Reveal
      className="section"
      style={{
        textAlign: "center",
        marginBottom: "70px",
      }}
    >
      <div
        className="section__content"
        style={{
          maxWidth: "760px",
          margin: "0 auto",
        }}
      >
        <h6
          className="section__sub"
          style={{
            justifyContent: "center",
            marginBottom: "18px",
          }}
        >
          {lang.value === "EN"
            ? "Latest Projects"
            : lang.value === "FR"
            ? "Derniers Projets"
            : "أحدث المشاريع"}
        </h6>

        <h2
          className="section__title"
          style={{
            fontSize: "clamp(38px,5vw,60px)",
            lineHeight: "1.15",
            marginBottom: "20px",
            fontWeight: "700",
          }}
        >
          {lang.value === "EN"
            ? "Powerful Digital"
            : lang.value === "FR"
            ? "Expériences Digitales"
            : "تجارب رقمية"}{" "}
          <strong>
            {lang.value === "EN"
              ? "Experiences"
              : lang.value === "FR"
              ? "Innovantes"
              : "احترافية"}
          </strong>
        </h2>

        <p
          style={{
            fontSize: "17px",
            lineHeight: "1.9",
            opacity: "0.75",
            margin: "0 auto",
            maxWidth: "650px",
          }}
        >
          {lang.value === "EN"
            ? "Discover high-end projects combining innovation, modern technologies and premium user experiences."
            : lang.value === "FR"
            ? "Découvrez des projets premium combinant innovation, technologies modernes et expériences utilisateurs exceptionnelles."
            : "اكتشف مشاريع احترافية تجمع بين الابتكار والتكنولوجيا الحديثة وتجارب المستخدم المميزة"}
        </p>
      </div>
    </Reveal>

    {/* PROJECT GRID */}
    <div className="modern-project-grid">
      {projects.slice(0, homeProjectCount).map((e, i) => (
        <Reveal
          key={i}
          className="project-grid-item"
          delay={0.08 + i * 0.06}
          y={30}
        >
          <div
            className="modern-project-card"
            onClick={() => setSelectedProject(e)}
          >
            {/* IMAGE */}
            <div className="project-image-wrapper">
              <img
                src={e?.images?.[0]}
                alt="project"
                className="project-image"
              />

              <div className="project-overlay" />
            </div>

            {/* CONTENT */}
            <div className="project-content">
              <div>
                <span className="project-tag">
                  {lang.value === "EN"
                    ? "Featured"
                    : lang.value === "FR"
                    ? "Premium"
                    : "مميز"}
                </span>

                <h3 className="project-title">
                  {lang.value === "EN"
                    ? e?.name
                    : lang.value === "FR"
                    ? e?.nameFR
                    : e?.nameAR}
                </h3>

                <p className="project-client">
                  {lang.value === "EN"
                    ? e?.client
                    : lang.value === "FR"
                    ? e?.clientFR
                    : e?.clientAR}
                </p>
              </div>

              <div className="project-arrow">
                <i className="fa-solid fa-arrow-right" />
              </div>
            </div>
          </div>
        </Reveal>
      ))}
    </div>

    {homeProjectCount < projects.length && (
      <div style={{ textAlign: "center", marginTop: 40 }}>
        <button
          className="ev-btn-primary"
          onClick={() => setHomeProjectCount((p) => p + 6)}
          style={{ cursor: "pointer", border: "none" }}
        >
          {lang.value === "EN" ? "Show More" : lang.value === "FR" ? "Voir plus" : "عرض المزيد"}
        </button>
      </div>
    )}
  </div>

  {/* STYLES */}
  <style jsx>{`
    .modern-project-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
    }

    .project-grid-item {
      width: 100%;
    }

    .modern-project-card {
      background: rgba(255, 255, 255, 0.03);
      border-radius: 26px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.4s ease;
      height: 100%;
      border: 1px solid rgba(255, 255, 255, 0.05);
      backdrop-filter: blur(10px);
    }

    .project-image-wrapper {
      position: relative;
      height: 260px;
      overflow: hidden;
    }

    .project-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.7s ease;
    }

    .project-overlay {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.45),
        rgba(0, 0, 0, 0.08),
        transparent
      );
    }

    .project-content {
      padding: 24px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      gap: 18px;
    }

    .project-tag {
      display: inline-flex;
      padding: 8px 16px;
      border-radius: 50px;
      background: rgba(255, 255, 255, 0.08);
      color: #fff;
      font-size: 12px;
      font-weight: 600;
      margin-bottom: 16px;
      backdrop-filter: blur(10px);
    }

    .project-title {
      color: #fff;
      font-size: 24px;
      line-height: 1.3;
      margin-bottom: 8px;
      font-weight: 700;
    }

    .project-client {
      color: rgba(255, 255, 255, 0.7);
      margin: 0;
      font-size: 14px;
      line-height: 1.7;
    }

    .project-arrow {
      width: 52px;
      height: 52px;
      min-width: 52px;
      border-radius: 50%;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.35s ease;
    }

    .project-arrow i {
      color: #111;
      font-size: 16px;
      transition: all 0.35s ease;
    }

    .modern-project-card:hover {
      transform: translateY(-8px);
      box-shadow: 0 20px 50px rgba(0, 0, 0, 0.18);
    }

    .modern-project-card:hover .project-image {
      transform: scale(1.08);
    }

    .modern-project-card:hover .project-arrow i {
      transform: rotate(-45deg);
    }

    @media (max-width: 991px) {
      .modern-project-grid {
        grid-template-columns: repeat(2, 1fr);
      }

      .project-image-wrapper {
        height: 230px;
      }
    }

    @media (max-width: 767px) {
      .modern-project-grid {
        grid-template-columns: 1fr;
      }

      .project-image-wrapper {
        height: 240px;
      }

      .project-content {
        padding: 20px;
      }

      .project-title {
        font-size: 22px;
      }
    }
  `}</style>
</section>

      {/* ================= MODAL ================= */}
      <AnimatePresence>
        {selectedProject && (
          <motion.div
            key="project-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={closeModal}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.75)",
              backdropFilter: "blur(12px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              padding: window.innerWidth < 768 ? "12px" : "24px",
            }}
          >
            <motion.div
              key="modal-card"
              initial={{ opacity: 0, scale: 0.92, y: 30 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.92, y: 30 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => e.stopPropagation()}
              style={{
                width: "100%",
                maxWidth: "960px",
                maxHeight: window.innerWidth < 768 ? "90vh" : "85vh",
                borderRadius: "24px",
                background:
                  "linear-gradient(135deg, rgba(7,8,22,0.98), rgba(15,16,35,0.98))",
                border: "1px solid rgba(201,161,74,0.2)",
                boxShadow: "0 40px 120px rgba(0,0,0,0.6)",
                overflow: "hidden",
                position: "relative",
                display: "flex",
                flexDirection: window.innerWidth < 768 ? "column" : "row",
              }}
            >
              {/* CLOSE */}
              <motion.button
                whileHover={{ scale: 1.1, rotate: 90 }}
                whileTap={{ scale: 0.9 }}
                onClick={closeModal}
                style={{
                  position: "absolute",
                  top: 14,
                  right: lang.value === "AR" ? "auto" : 14,
                  left: lang.value === "AR" ? 14 : "auto",
                  background: "rgba(201,161,74,0.15)",
                  border: "1px solid rgba(201,161,74,0.35)",
                  color: "#ecc879",
                  borderRadius: "50%",
                  width: 36,
                  height: 36,
                  cursor: "pointer",
                  fontSize: 15,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 10,
                  backdropFilter: "blur(4px)",
                }}
              >
                ✕
              </motion.button>

              {/* IMAGE SIDE */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                style={{
                  width: window.innerWidth < 768 ? "100%" : "45%",
                  minHeight: window.innerWidth < 768 ? "200px" : "auto",
                  position: "relative",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                <img
                  src={selectedProject?.images?.[0]}
                  alt="project"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    position: "absolute",
                    inset: 0,
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(180deg, transparent 60%, rgba(7,8,22,0.9) 100%)",
                  }}
                />
                {/* gold corner accent */}
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 2,
                    background:
                      "linear-gradient(90deg, transparent, #c9a14a, transparent)",
                  }}
                />
              </motion.div>

              {/* CONTENT SIDE */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.15 }}
                style={{
                  flex: 1,
                  padding: window.innerWidth < 768 ? "20px" : "32px",
                  overflowY: "auto",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Category tag */}
                {selectedProject?.category && (
                  <span
                    style={{
                      display: "inline-flex",
                      alignSelf: "flex-start",
                      padding: "4px 14px",
                      borderRadius: 999,
                      border: "1px solid rgba(201,161,74,0.3)",
                      background: "rgba(201,161,74,0.08)",
                      color: "#c9a14a",
                      fontSize: 10,
                      fontWeight: 700,
                      letterSpacing: "2px",
                      textTransform: "uppercase",
                      marginBottom: 12,
                    }}
                  >
                    {selectedProject.category}
                  </span>
                )}

                {/* Title */}
                <h2
                  style={{
                    color: "#fff",
                    fontWeight: 800,
                    fontSize: window.innerWidth < 768 ? 20 : 26,
                    margin: 0,
                    lineHeight: 1.2,
                  }}
                >
                  {lang.value === "EN"
                    ? selectedProject?.name
                    : lang.value === "FR"
                      ? selectedProject?.nameFR
                      : selectedProject?.nameAR}
                </h2>

                {/* Client */}
                <p
                  style={{
                    color: "#ecc879",
                    marginTop: 8,
                    fontSize: 13,
                    fontWeight: 600,
                    letterSpacing: "0.5px",
                  }}
                >
                  {lang.value === "EN"
                    ? selectedProject?.client
                    : lang.value === "FR"
                      ? selectedProject?.clientFR
                      : selectedProject?.clientAR}
                </p>

                {/* Gold divider */}
                <div
                  style={{
                    width: 60,
                    height: 1.5,
                    background:
                      "linear-gradient(90deg, #c9a14a, transparent)",
                    margin: "16px 0",
                  }}
                />

                {/* Description */}
                <p
                  style={{
                    color: "#9ca3af",
                    lineHeight: 1.8,
                    fontSize: 14.5,
                    margin: 0,
                    flex: 1,
                  }}
                >
                  {lang.value === "EN"
                    ? selectedProject?.description
                    : lang.value === "FR"
                      ? selectedProject?.descriptionFR
                      : selectedProject?.descriptionAR}
                </p>

                {/* CTA */}
                <div
                  style={{
                    marginTop: 24,
                    display: "flex",
                    gap: 10,
                    flexWrap: "wrap",
                  }}
                >
                  <motion.button
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                    onClick={closeModal}
                    style={{
                      padding: "11px 24px",
                      borderRadius: 999,
                      background:
                        "linear-gradient(135deg, #c9a14a, #b8942e)",
                      border: "none",
                      color: "#070816",
                      fontWeight: 700,
                      fontSize: 13,
                      cursor: "pointer",
                      letterSpacing: "0.3px",
                    }}
                  >
                    {lang.value === "EN"
                      ? "Got it"
                      : lang.value === "FR"
                        ? "Compris"
                        : "حسناً"}
                  </motion.button>

                </div>
              </motion.div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      {/* our project end */}

      <div className="counter-five-area-envent counter-five-area pt-100 mt-50 pb-70">
        <div className="container">
          <div className="row align-items-start">
            <Reveal className="col-lg-6">
              <div className="counter-five-content">
                <h3>
                  {" "}
                  {lang.value === "EN"
                    ? "We Create Websites Business Services , AI , IOT "
                    : lang.value === "FR"
                      ? "Nous créons des sites Web, des services aux entreprises, de l'IA, de l'IOT"
                      : "نحن نقوم بإنشاء مواقع الويب وخدمات الأعمال والذكاء الاصطناعي وإنترنت الأشياء"}{" "}
                </h3>
                <OrnamentalDivider width={200} />
                <p>
                  {lang.value === "EN"
                    ? " Our approach is centered around understanding the unique objectives and challenges of each client."
                    : lang.value === "FR"
                      ? "Notre approche est centrée sur la compréhension des objectifs et des défis uniques de chaque client."
                      : "يتمحور نهجنا حول فهم الأهداف والتحديات الفريدة لكل عميل."}
                </p>
              </div>
            </Reveal>
            <Reveal className="col-lg-6" delay={0.1}>
              <div className="row">
                <Reveal className="col-lg-6 col-md-3 col-sm-6" delay={0.15}>
                  <div className="counter-single-item-five color">
                    <h2>
                      <AnimatedCounter value={1200} suffix="+" />{" "}
                      <img src={down1} alt="up" style={{ transform: "rotate(180deg)" }} />
                    </h2>
                    <span>
                      {" "}
                      {lang.value === "EN"
                        ? "Happy Customers"
                        : lang.value === "FR"
                          ? "Clients satisfaits"
                          : "العملاء السعداء"}{" "}
                    </span>
                  </div>
                </Reveal>
                <Reveal className="col-lg-6 col-md-3 col-sm-6" delay={0.25}>
                  <div className="counter-single-item-five">
                    <h2>
                      <AnimatedCounter value={3500} suffix="+" />{" "}
                      <img src={down2} alt="up" style={{ transform: "rotate(180deg)" }} />
                    </h2>
                    <span>
                      {" "}
                      {lang.value === "EN"
                        ? "Success Project"
                        : lang.value === "FR"
                          ? "Projet de réussite"
                          : "مشروع النجاح"}{" "}
                    </span>
                  </div>
                </Reveal>
                <Reveal className="col-lg-6 col-md-3 col-sm-6" delay={0.35}>
                  <div className="counter-single-item-five ms-100">
                    <h2>
                      <AnimatedCounter value={150} suffix="%" />{" "}
                      <img src={down2} alt="up" style={{ transform: "rotate(180deg)" }} />
                    </h2>
                    <span>
                      {" "}
                      {lang.value === "EN"
                        ? "Conversion Rate Increased"
                        : lang.value === "FR"
                          ? "Taux de conversion augmenté"
                          : "زيادة معدل التحويل"}{" "}
                    </span>
                  </div>
                </Reveal>
                <Reveal className="col-lg-6 col-md-3 col-sm-6" delay={0.45}>
                  <div className="counter-single-item-five ms-100">
                    <h2>
                      <AnimatedCounter value={50} suffix="+" />{" "}
                      <img src={down2} alt="up" style={{ transform: "rotate(180deg)" }} />
                    </h2>
                    <span>
                      {" "}
                      {lang.value === "EN"
                        ? "Awards Winning"
                        : lang.value === "FR"
                          ? "Récompenses"
                          : "الحائز على جوائز"}{" "}
                    </span>
                  </div>
                </Reveal>
              </div>
            </Reveal>
          </div>
        </div>
      </div>

      {/* <section className="team pt-70 pb-70" id="teamid">
        <div className="container">
          <div className="section">
            <div className="section__content">
              <h6 className="section__sub">
                {" "}
                {lang.value === "EN"
                  ? "Our Team"
                  : lang.value === "FR"
                  ? "Notre équipe"
                  : "فريقنا"}
              </h6>
              <h3 className="section__title">
                {lang.value === "EN"
                  ? "Our Experienced"
                  : lang.value === "FR"
                  ? "Notre expérience"
                  : "خبرائنا"}{" "}
                <strong>
                  {lang.value === "EN"
                    ? "Our Team"
                    : lang.value === "FR"
                    ? "Notre équipe"
                    : "فريقنا"}
                </strong>{" "}
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-6 col-md-6">
              <div className="team__single">
                <div className="team__single--box">
                  <div className="team__single--wrap">
                    <img className="img-fluid" src={iheb} alt="" />
                    <div className="team-meta">
                      <div className="team-meta-info">
                        <a href="#">Iheb Baccouche</a>
                        <span>Full Stack Developer</span>
                      </div>
                      <div className="team-meta-social">
                        <div className="icon">
                          <i className="fa-solid fa-plus" />
                        </div>
                        <div className="social-links">
                          <a href="https://wa.me/+21656712636" target="_blank">
                            <i className="fa-brands fa-whatsapp" />
                          </a>
                          <a
                            href="https://www.linkedin.com/in/iheb-baccouche-5b98b9200/"
                            target="_blank"
                          >
                            <i className="fa-brands fa-linkedin" />
                          </a>
                          <a href="https://github.com/Ihebbac" target="_blank">
                            <i className="fa-brands fa-github" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {data?.Teams?.length !== 0 &&
              data?.Teams?.map((el) => (
                <div className="col-xl-3 col-lg-6 col-md-6">
                  <div className="team__single">
                    <div className="team__single--box">
                      <div className="team__single--wrap">
                        <img className="img-fluid" src={el.image} alt="" />
                        <div className="team-meta">
                          <div className="team-meta-info">
                            <a href="#">
                              {lang.value === "EN"
                                ? el.fullName
                                : lang.value === "FR"
                                ? el.fullNameFR
                                : el.fullNameAR}
                            </a>
                            <span>
                              {lang.value === "EN"
                                ? el.position
                                : lang.value === "FR"
                                ? el.positionFR
                                : el.positionAR}
                            </span>
                          </div>
                          <div className="team-meta-social">
                            <div className="icon">
                              <i className="fa-solid fa-plus" />
                            </div>
                            <div className="social-links">
                              <a href={el?.whatsapp ?? "#"} target="_blank">
                                <i className="fa-brands fa-whatsapp" />
                              </a>
                              <a href={el?.linkedIn ?? "#"} target="_blank">
                                <i className="fa-brands fa-linkedin" />
                              </a>
                              <a href={el?.github ?? "#"} target="_blank">
                                <i className="fa-brands fa-github" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section> */}

      {/* sponsor */}
      {partners.length > 0 && (
        <div className="sponsor style-two">
          <div className="container">
            <Swiper
              slidesPerView={3}
              spaceBetween={30}
              breakpoints={{
                500: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
              }}
              pagination={{
                clickable: true,
              }}
              className="mySwiper"
            >
              {partners.map((e) => (
                <SwiperSlide className="swiper-slide">
                  {" "}
                  <div key="sponsor1">
                    <img src={e?.image} alt="" width={150} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}
      {/* sponsor end */}

      {/* breadcrumb */}
      {/* <div className="breadcrumb pt-80 pb-80" id="contactid">
        <div className="container">
          <div className="breadcrumb__vector">
            <img src="assets/img/animated-icon/graph.png" alt="graph" />
            <img src="assets/img/animated-icon/star-icon.png" alt="graph" />
          </div>
          <div className="breadcrumb__wrapper">
            <div className="breadcrumb__wrapper--text">
              <h5 className="title">
                {" "}
                {lang.value === "EN"
                  ? `Contact Us`
                  : lang.value === "FR"
                    ? `Contactez-nous`
                    : `اتصل بنا`}{" "}
              </h5>
              <p>
                {lang.value === "EN"
                  ? `For businesses with digital products or services, ensuring a
                visually appealing interface is vital.`
                  : lang.value === "FR"
                    ? `Pour les entreprises proposant des produits ou des services numériques, il est essentiel de garantir une interface
visuellement attrayante.`
                    : `بالنسبة للشركات التي لديها منتجات أو خدمات رقمية، فإن ضمان وجود واجهة جذابة بصريًا أمر حيوي.`}
              </p>
            </div>
          </div>
        </div>
      </div> */}
      {/* breadcrumb end */}

      {/* contact us */}
    <div className="contact pt-100 pb-100 position-relative overflow-hidden">
  <div className="container">
    {/* HEADER */}
    <Reveal
      className="section"
      style={{
        textAlign: "center",
        marginBottom: "65px",
      }}
    >
      <div
        className="section__content"
        style={{
          maxWidth: "760px",
          margin: "0 auto",
        }}
      >
        <h6
          className="section__sub"
          style={{
            justifyContent: "center",
            marginBottom: "18px",
          }}
        >
          {lang.value === "EN"
            ? "Contact Us"
            : lang.value === "FR"
            ? "Contactez-nous"
            : "اتصل بنا"}
        </h6>

        <h2
          className="section__title"
          style={{
            fontSize: "clamp(38px,5vw,58px)",
            lineHeight: "1.15",
            marginBottom: "20px",
          }}
        >
          {lang.value === "EN"
            ? "Let's Create Something"
            : lang.value === "FR"
            ? "Créons Quelque Chose"
            : "لنصنع شيئاً"}{" "}
          <strong>
            {lang.value === "EN"
              ? "Exceptional"
              : lang.value === "FR"
              ? "d'Exception"
              : "استثنائياً"}
          </strong>
        </h2>

        <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
          <OrnamentalDivider width={240} />
        </div>

        <p
          style={{
            maxWidth: "650px",
            margin: "0 auto",
            opacity: "0.75",
            lineHeight: "1.9",
            fontSize: "16px",
          }}
        >
          {lang.value === "EN"
            ? "Contact our team and build powerful digital experiences with premium creativity and innovation."
            : lang.value === "FR"
            ? "Contactez notre équipe et créez des expériences digitales premium avec créativité et innovation."
            : "تواصل معنا لإنشاء تجارب رقمية احترافية بإبداع وابتكار"}
        </p>
      </div>
    </Reveal>

    {/* CONTACT BOX */}
    <div className="modern-contact-wrapper">
      {/* LEFT INFO */}
      <div className="modern-contact-info">
        <div className="modern-contact-card">
          <div className="modern-contact-card__glow" />
          <div className="icon">
            <i className="fa-solid fa-phone" />
          </div>

          <div className="content">
            <span>
              {lang.value === "EN"
                ? "Phone"
                : lang.value === "FR"
                ? "Téléphone"
                : "الهاتف"}
            </span>

            <a href={`tel:${config?.phone}`}>{config?.phone}</a>
            <a href={`mailto:${config?.email}`}>{config?.email}</a>
          </div>
        </div>

        <div className="modern-contact-card">
          <div className="modern-contact-card__glow" />
          <div className="icon">
            <i className="fa-solid fa-location-dot" />
          </div>

          <div className="content">
            <span>
              {lang.value === "EN"
                ? "Address"
                : lang.value === "FR"
                ? "Adresse"
                : "العنوان"}
            </span>

            <p>
              {lang.value === "EN"
                ? config?.address
                : lang.value === "FR"
                ? config?.addressFR
                : config?.addressAR}
            </p>
          </div>
        </div>

        <div className="modern-contact-card">
          <div className="modern-contact-card__glow" />
          <div className="icon">
            <i className="fa-regular fa-clock" />
          </div>

          <div className="content">
            <span>
              {lang.value === "EN"
                ? "Opening Hours"
                : lang.value === "FR"
                ? "Heures d'ouverture"
                : "ساعات العمل"}
            </span>

            <p>
              {lang.value === "EN"
                ? config?.openingDayStart
                : lang.value === "FR"
                ? config?.openingDayStartFR
                : config?.openingDayStartAR}
              {" - "}
              {lang.value === "EN"
                ? config?.openingDayEnd
                : lang.value === "FR"
                ? config?.openingDayEndFR
                : config?.openingDayEndAR}
            </p>

            <p>
              {lang.value === "EN"
                ? config?.openingHourStart
                : lang.value === "FR"
                ? config?.openingHourStartFR
                : config?.openingHourStartAR}
              {" - "}
              {lang.value === "EN"
                ? config?.openingHourEnd
                : lang.value === "FR"
                ? config?.openingHourEndFR
                : config?.openingHourEndAR}
            </p>
          </div>
        </div>
      </div>

      {/* FORM */}
      <Reveal delay={0.2} y={40}>
        <div className="modern-contact-form">
          <form className="contact__php">
            <div className="row">
              <div className="col-lg-6">
                <div className="modern-input">
                  <input
                    type="text"
                    placeholder={
                      lang.value === "EN"
                        ? "Full Name"
                        : lang.value === "FR"
                        ? "Nom et prénom"
                        : "الاسم الكامل"
                    }
                    onChange={(e) => {
                      setfullName(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="modern-input">
                  <input
                    type="email"
                    placeholder={
                      lang.value === "EN"
                        ? "Email Address"
                        : lang.value === "FR"
                        ? "Adresse email"
                        : "البريد الإلكتروني"
                    }
                    onChange={(e) => {
                      setemail(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="modern-input">
                  <input
                    type="number"
                    placeholder={
                      lang.value === "EN"
                        ? "Phone Number"
                        : lang.value === "FR"
                        ? "Numéro de téléphone"
                        : "رقم الهاتف"
                    }
                    min={1}
                    onChange={(e) => {
                      setphone(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="modern-input">
                  <input
                    type="text"
                    placeholder={
                      lang.value === "EN"
                        ? "Skype Address"
                        : lang.value === "FR"
                        ? "Adresse Skype"
                        : "عنوان سكايب"
                    }
                    onChange={(e) => {
                      setskype(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="modern-input">
                  <textarea
                    rows={6}
                    placeholder={
                      lang.value === "EN"
                        ? "Write your message..."
                        : lang.value === "FR"
                        ? "Écrivez votre message..."
                        : "اكتب رسالتك..."
                    }
                    onChange={(e) => {
                      setmessage(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="col-12">
                <button
                  className="modern-contact-btn"
                  onClick={(e) => addContact(e)}
                >
                  <span>
                    {lang.value === "EN"
                      ? "Send Message"
                      : lang.value === "FR"
                      ? "Envoyer un message"
                      : "إرسال الرسالة"}
                  </span>

                  <i className="fa-solid fa-arrow-right-long" />
                </button>
              </div>
            </div>
          </form>
        </div>
      </Reveal>
    </div>
  </div>

  {/* STYLE */}
  <style jsx>{`
    /* ---------- BACKGROUND GLOW ORBS ---------- */
    .contact.position-relative.overflow-hidden::before {
      content: "";
      position: absolute;
      inset: 0;
      z-index: 0;
      pointer-events: none;
      background:
        radial-gradient(ellipse 600px 400px at 10% 30%, rgba(212, 175, 55, 0.07) 0%, transparent 70%),
        radial-gradient(ellipse 500px 500px at 90% 70%, rgba(212, 175, 55, 0.05) 0%, transparent 70%);
    }

    .contact.position-relative.overflow-hidden > .container {
      position: relative;
      z-index: 1;
    }

    /* ---------- WRAPPER ---------- */
    .modern-contact-wrapper {
      display: grid;
      grid-template-columns: 360px 1fr;
      gap: 30px;
      align-items: stretch;
    }

    /* ---------- INFO CARDS ---------- */
    .modern-contact-info {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    .modern-contact-card {
      position: relative;
      overflow: hidden;
      padding: 30px;
      border-radius: 28px;
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(255, 215, 120, 0.12);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      transition: all 0.45s cubic-bezier(0.22, 1, 0.36, 1);
    }

    .modern-contact-card::after {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: inherit;
      opacity: 0;
      background: linear-gradient(
        160deg,
        rgba(255, 215, 120, 0.04) 0%,
        transparent 50%
      );
      transition: opacity 0.45s ease;
      pointer-events: none;
    }

    .modern-contact-card:hover::after {
      opacity: 1;
    }

    .modern-contact-card__glow {
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(
        circle at 50% 50%,
        rgba(255, 215, 120, 0.04) 0%,
        transparent 60%
      );
      opacity: 0;
      transition: opacity 0.6s ease;
      pointer-events: none;
    }

    .modern-contact-card:hover .modern-contact-card__glow {
      opacity: 1;
    }

    .modern-contact-card:hover {
      transform: translateY(-8px);
      border-color: rgba(255, 215, 120, 0.3);
      box-shadow:
        0 24px 60px -16px rgba(0, 0, 0, 0.2),
        0 0 0 1px rgba(255, 215, 120, 0.06) inset;
    }

    .modern-contact-card .icon {
      position: relative;
      z-index: 1;
      width: 62px;
      height: 62px;
      border-radius: 20px;
      background: linear-gradient(
        135deg,
        rgba(255, 215, 120, 0.25),
        rgba(255, 215, 120, 0.08)
      );
      color: #d4af37;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      margin-bottom: 22px;
      border: 1px solid rgba(255, 215, 120, 0.15);
      transition: all 0.4s ease;
    }

    .modern-contact-card:hover .icon {
      background: linear-gradient(
        135deg,
        rgba(255, 215, 120, 0.35),
        rgba(255, 215, 120, 0.15)
      );
      border-color: rgba(255, 215, 120, 0.35);
      transform: scale(1.05);
      box-shadow: 0 0 30px rgba(212, 175, 55, 0.12);
    }

    .modern-contact-card .content span {
      position: relative;
      z-index: 1;
      display: block;
      color: #fff;
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 14px;
    }

    .modern-contact-card .content a,
    .modern-contact-card .content p {
      position: relative;
      z-index: 1;
      display: block;
      color: rgba(255, 255, 255, 0.72);
      line-height: 1.8;
      margin-bottom: 8px;
      transition: 0.3s ease;
    }

    .modern-contact-card .content a:hover {
      color: #d4af37;
    }

    /* ---------- FORM ---------- */
    .modern-contact-form {
      height: 100%;
      padding: 40px;
      border-radius: 32px;
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(255, 215, 120, 0.12);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      transition: border-color 0.4s ease;
    }

    .modern-contact-form:focus-within {
      border-color: rgba(255, 215, 120, 0.2);
    }

    .modern-input {
      margin-bottom: 24px;
    }

    .modern-input input,
    .modern-input textarea {
      width: 100%;
      border: 1px solid rgba(255, 215, 120, 0.08);
      background: rgba(255, 255, 255, 0.03);
      height: 62px;
      border-radius: 18px;
      padding: 0 22px;
      color: #fff;
      font-size: 15px;
      transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
      outline: none;
    }

    .modern-input textarea {
      height: auto;
      padding-top: 20px;
      resize: none;
    }

    .modern-input input:focus,
    .modern-input textarea:focus {
      border-color: rgba(255, 215, 120, 0.45);
      box-shadow:
        0 0 0 4px rgba(255, 215, 120, 0.08),
        0 8px 24px rgba(0, 0, 0, 0.08);
      transform: translateY(-3px);
      background: rgba(255, 255, 255, 0.06);
    }

    .modern-input input::placeholder,
    .modern-input textarea::placeholder {
      color: rgba(255, 255, 255, 0.45);
      transition: opacity 0.3s ease;
    }

    .modern-input input:focus::placeholder,
    .modern-input textarea:focus::placeholder {
      opacity: 0.5;
    }

    /* ---------- BUTTON ---------- */
    .modern-contact-btn {
      position: relative;
      height: 60px;
      border: none;
      padding: 0 38px;
      border-radius: 100px;
      background: linear-gradient(135deg, #d4af37, #f1d77a);
      color: #111;
      font-weight: 700;
      font-size: 16px;
      display: inline-flex;
      align-items: center;
      gap: 14px;
      cursor: pointer;
      transition: all 0.4s cubic-bezier(0.22, 1, 0.36, 1);
      box-shadow: 0 10px 30px rgba(212, 175, 55, 0.22);
      overflow: hidden;
    }

    .modern-contact-btn::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: inherit;
      background: linear-gradient(135deg, #f1d77a, #d4af37);
      opacity: 0;
      transition: opacity 0.4s ease;
    }

    .modern-contact-btn i {
      position: relative;
      z-index: 1;
      transition: 0.35s cubic-bezier(0.22, 1, 0.36, 1);
      font-size: 15px;
    }

    .modern-contact-btn span {
      position: relative;
      z-index: 1;
    }

    .modern-contact-btn:hover {
      transform: translateY(-4px) scale(1.02);
      box-shadow: 0 20px 48px rgba(212, 175, 55, 0.35);
    }

    .modern-contact-btn:hover::before {
      opacity: 1;
    }

    .modern-contact-btn:hover i {
      transform: translateX(6px) scale(1.1);
    }

    .modern-contact-btn:active {
      transform: translateY(-1px) scale(0.98);
    }

    /* ---------- RESPONSIVE ---------- */
    @media (max-width: 991px) {
      .modern-contact-wrapper {
        grid-template-columns: 1fr;
      }

      .modern-contact-form {
        padding: 30px;
      }
    }

    @media (max-width: 767px) {
      .modern-contact-form {
        padding: 24px;
        border-radius: 24px;
      }

      .modern-contact-card {
        padding: 24px;
        border-radius: 22px;
      }

      .modern-input input,
      .modern-input textarea {
        border-radius: 14px;
      }

      .modern-contact-btn {
        width: 100%;
        justify-content: center;
      }
    }
  `}</style>
</div>
      {/* contact us end */}
      {/* map */}
      <div className="contact__map">
        <div id="map">
          {/* if you want to use leaflet map just remove <iframe></iframe> */}
          <iframe
            className="google__map w-100"
            src="https://maps.google.com/maps?q=QFC%20tower%2C%20Doha-Qatar&t=m&z=11&output=embed&iwloc=near"
          ></iframe>
        </div>
      </div>
      {/* map end */}

      {/* footer */}
      <footer className="footer pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="footer__widget">
                <h5>Contact Us</h5>
                <div className="footer__widget--contact">
                  <ul>
                    <li>
                      <i className="fa-sharp fa-solid fa-phone" />
                      <a href={`tel:${config?.phone}`}>{config?.phone}</a>
                    </li>
                    <li>
                      <i className="fa-regular fa-envelope" />
                      <a href={`mailto:${config?.email}`}> {config?.email}</a>
                    </li>
                  </ul>
                  {/* <div className="footer__social">
                    <a href="#">
                      <i className="fa-brands fa-facebook-f" />
                    </a>
                    <a href="#">
                      <i className="fa-brands fa-twitter" />
                    </a>
                    <a href="#">
                      <i className="fa-brands fa-instagram" />
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6">
              <div className="footer__widget">
                <h5>
                  {lang.value === "EN"
                    ? `Links`
                    : lang.value === "FR"
                      ? `Links`
                      : `الروابط`}{" "}
                </h5>
                <div className="footer__widget--link">
                  <ul>
                    <li>
                      <a href="#homeid" onClick={(e) => setmenu(false)}>
                        {lang.value === "EN"
                          ? `Home`
                          : lang.value === "FR"
                            ? `Accueil`
                            : `الصفحة الرئيسية`}
                      </a>
                    </li>
                    <li>
                      <a href="#aboutid" onClick={(e) => setmenu(false)}>
                        {lang.value === "EN"
                          ? `About`
                          : lang.value === "FR"
                            ? `À propos de nous`
                            : `معلومات عنا`}
                      </a>
                    </li>
                    <li>
                      <a href="#projectsid" onClick={(e) => setmenu(false)}>
                        {lang.value === "EN"
                          ? `Portfolio`
                          : lang.value === "FR"
                            ? `Portefeuille`
                            : `المشاريع`}
                      </a>
                    </li>
                    <li>
                      <a href="#Servicesid" onClick={(e) => setmenu(false)}>
                        {lang.value === "EN"
                          ? `Services`
                          : lang.value === "FR"
                            ? `Services`
                            : `خدمات`}
                      </a>
                    </li>
                    {/* <li>
                      <a href="#teamid" onClick={(e) => setmenu(false)}>
                        {lang.value === "EN"
                          ? `Team`
                          : lang.value === "FR"
                          ? `Équipe`
                          : `فريق`}
                      </a>
                    </li> */}
                    <li>
                      <a href="#contactid" onClick={(e) => setmenu(false)}>
                        {lang.value === "EN"
                          ? `Contact`
                          : lang.value === "FR"
                            ? `Contact`
                            : `اتصال`}
                      </a>
                    </li>

                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          navigate("/events");
                          setmenu(false);
                        }}
                      >
                        {lang.value === "EN"
                          ? `HMA Events`
                          : lang.value === "FR"
                            ? `Événements HMA`
                            : `فعاليات HMA`}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-2 col-md-6 col-sm-6">
              <div className="footer__widget">
                <h5>Resources</h5>
                <div className="footer__widget--resource">
                  <ul>
                    <li>
                      <a href="#">Help Center</a>
                    </li>
                    <li>
                      <a href="#">User Guide</a>
                    </li>
                    <li>
                      <a href="#">Realease</a>
                    </li>
                    <li>
                      <a href="#">Video tutorial </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
            <div className="col-lg-5 col-md-6 col-sm-6">
              <div className="footer__widget">
                <h5>
                  {lang.value === "EN"
                    ? `Newsletter`
                    : lang.value === "FR"
                      ? `Bulletin`
                      : `نشرة`}{" "}
                </h5>
                <div className="footer__widget--newsletter">
                  <p>
                    {lang.value === "EN"
                      ? `   If your business hosts events or exhibitions, creative
                    services can assist with event planning, booth design.`
                      : lang.value === "FR"
                        ? `Si votre entreprise organise des événements ou des expositions, des services créatifs peuvent vous aider à planifier vos événements et à concevoir des stands.`
                        : `إذا كان عملك يستضيف فعاليات أو معارض، كن مبدعًا
 يمكن أن تساعد الخدمات في تخطيط الأحداث وتصميم الكشك.`}
                  </p>
                  <form action="#" className="newsletter-box">
                    <input type="email" placeholder="" />
                    <button type="submit">
                      {lang.value === "EN"
                        ? `Submit`
                        : lang.value === "FR"
                          ? `Soumettre.`
                          : `لإرسال`}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* footer end */}
      {/* footer credit */}
      <div className="footer-credit">
        <div className="container">
          <div className="footer-credit--img">
            <a onClick={() => navigate("/")}>
              <img src={Logo} alt="footer logo" />
            </a>
          </div>
          <div className="footer-credit__wrapper mt-25">
            <div className="copy-right">
              {lang.value === "EN"
                ? `Copyright`
                : lang.value === "FR"
                  ? `Copyright`
                  : `حقوق الطبع والنشر`}{" "}
              © {new Date().getFullYear()} - <a href="#"> HMA Techs</a>
              {lang.value === "EN"
                ? `All Rights Reserved`
                : lang.value === "FR"
                  ? `Tous droits réservés `
                  : ` جميع الحقوق محفوظة`}
            </div>
          </div>
        </div>
      </div>
      {/* footer credit end */}

      {/* ============= WHAT WE DO MODAL ============= */}
      <AnimatePresence>
        {modalopen && item && (
          <motion.div
            key="service-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={() => setmodalopen(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.75)",
              backdropFilter: "blur(12px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              padding: window.innerWidth < 768 ? "12px" : "24px",
            }}
          >
            <motion.div
              key="service-modal-card"
              initial={{ opacity: 0, scale: 0.92, y: 30 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.92, y: 30 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => e.stopPropagation()}
              style={{
                width: "100%",
                maxWidth: "720px",
                borderRadius: "24px",
                background:
                  "linear-gradient(135deg, rgba(7,8,22,0.98), rgba(15,16,35,0.98))",
                border: "1px solid rgba(201,161,74,0.2)",
                boxShadow: "0 40px 120px rgba(0,0,0,0.6)",
                overflow: "hidden",
                position: "relative",
              }}
            >
              {/* Gold top accent bar */}
              <div
                style={{
                  height: 3,
                  background:
                    "linear-gradient(90deg, transparent, #c9a14a, #b8942e, #c9a14a, transparent)",
                }}
              />

              {/* CLOSE */}
              <motion.button
                whileHover={{ scale: 1.1, rotate: 90 }}
                whileTap={{ scale: 0.9 }}
                onClick={() => setmodalopen(false)}
                style={{
                  position: "absolute",
                  top: 14,
                  right: lang.value === "AR" ? "auto" : 14,
                  left: lang.value === "AR" ? 14 : "auto",
                  background: "rgba(201,161,74,0.15)",
                  border: "1px solid rgba(201,161,74,0.35)",
                  color: "#ecc879",
                  borderRadius: "50%",
                  width: 36,
                  height: 36,
                  cursor: "pointer",
                  fontSize: 15,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 10,
                  backdropFilter: "blur(4px)",
                }}
              >
                ✕
              </motion.button>

              {/* Decorative left gradient bar */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: lang.value === "AR" ? "auto" : 0,
                  right: lang.value === "AR" ? 0 : "auto",
                  width: 4,
                  height: "100%",
                  background:
                    "linear-gradient(180deg, #c9a14a, rgba(201,161,74,0.1))",
                }}
              />

              <div
                style={{
                  padding: window.innerWidth < 768 ? "32px 20px" : "40px",
                }}
              >
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                >
                  {/* Decorative number */}
                  <span
                    style={{
                      fontSize: 48,
                      fontWeight: 200,
                      color: "rgba(201,161,74,0.12)",
                      lineHeight: 1,
                      display: "block",
                      marginBottom: 8,
                      fontFamily: "serif",
                    }}
                  >
                    {String(
                      (services || []).findIndex(
                        (s) =>
                          s.title === item?.title ||
                          s.titleFR === item?.titleFR
                      ) + 1 || ""
                    ).padStart(2, "0")}
                  </span>

                  {/* EYEBROW */}
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                      color: "#c9a14a",
                      fontSize: 10,
                      fontWeight: 700,
                      letterSpacing: "3px",
                      textTransform: "uppercase",
                      marginBottom: 12,
                    }}
                  >
                    <span
                      style={{
                        width: 20,
                        height: 1.5,
                        background: "#c9a14a",
                      }}
                    />
                    {lang.value === "EN"
                      ? "What We Do"
                      : lang.value === "FR"
                        ? "Notre Service"
                        : "ماذا نفعل"}
                  </span>

                  {/* TITLE */}
                  <h2
                    style={{
                      color: "#fff",
                      fontWeight: 800,
                      fontSize: window.innerWidth < 768 ? 22 : 28,
                      margin: "8px 0 0",
                      lineHeight: 1.2,
                    }}
                  >
                    {lang.value === "EN"
                      ? item?.title
                      : lang.value === "FR"
                        ? item?.titleFR
                        : item?.titleAR}
                  </h2>

                  {/* Gold divider */}
                  <div
                    style={{
                      width: 80,
                      height: 1.5,
                      background:
                        "linear-gradient(90deg, #c9a14a, transparent)",
                      margin: "20px 0",
                    }}
                  />

                  {/* DESCRIPTION */}
                  <p
                    style={{
                      color: "#9ca3af",
                      lineHeight: 1.9,
                      fontSize: 15,
                      margin: 0,
                    }}
                  >
                    {lang.value === "EN"
                      ? item?.description
                      : lang.value === "FR"
                        ? item?.descriptionFR
                        : item?.descriptionAR}
                  </p>

                  {/* CTA */}
                  <motion.button
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                    onClick={() => setmodalopen(false)}
                    style={{
                      marginTop: 28,
                      padding: "12px 28px",
                      borderRadius: 999,
                      background:
                        "linear-gradient(135deg, #c9a14a, #b8942e)",
                      border: "none",
                      color: "#070816",
                      fontWeight: 700,
                      fontSize: 13,
                      cursor: "pointer",
                      letterSpacing: "0.3px",
                    }}
                  >
                    {lang.value === "EN"
                      ? "Got it"
                      : lang.value === "FR"
                        ? "Compris"
                        : "حسناً"}
                  </motion.button>
                </motion.div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Home;
